import React, { useId } from 'react';

// Brand-gradient "list view" icon (3 rows, each a bullet + line) for the Deal Flow
// view toggle. The source art is 18x16, so height follows that ratio to avoid
// squashing when `size` changes.
// useId keeps every gradient id unique per instance (same pattern as the other
// gradient icons).
const ListViewGradientIcon = ({ size = 18, style = {} }) => {
  const id = useId();
  const g = (n) => `list_g${n}_${id}`;

  const stops = (
    <>
      <stop stopColor="#7852F8" />
      <stop offset="1" stopColor="#84AEF6" />
    </>
  );

  return (
    <svg
      width={size}
      height={(size * 16) / 18}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', ...style }}
    >
      <path d="M5 3H18" stroke={`url(#${g(4)})`} />
      <circle cx="2" cy="3" r="1.5" stroke={`url(#${g(5)})`} />
      <path d="M5 8H18" stroke={`url(#${g(0)})`} />
      <circle cx="2" cy="8" r="1.5" stroke={`url(#${g(1)})`} />
      <path d="M5 13H18" stroke={`url(#${g(2)})`} />
      <circle cx="2" cy="13" r="1.5" stroke={`url(#${g(3)})`} />
      <defs>
        <linearGradient id={g(0)} x1="11.5" y1="9" x2="11.5" y2="10" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g(1)} x1="2" y1="6" x2="2" y2="10" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g(2)} x1="11.5" y1="13" x2="11.5" y2="14" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g(3)} x1="2" y1="11" x2="2" y2="15" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g(4)} x1="11.5" y1="4" x2="11.5" y2="5" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g(5)} x1="2" y1="1" x2="2" y2="5" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
      </defs>
    </svg>
  );
};

export default ListViewGradientIcon;
